import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useAllTeachers } from "../../../../../_hooks/person/useAllTeachers.hook";
import ObjectMultiSelect from "../../../../../widgets/select/object_multi_select";
import { useEditForm } from "../../../../../_hooks/form/use-edit-form.hook";

export default function TeahersModal({ formId }){

    const teachersHook = useAllTeachers();
    const hook = useEditForm(formId);

    const [show, setShow] = React.useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    return(
        <>
            <div onClick={handleShow} className="flex-col flex-center" style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', borderRadius: '10px', padding: '10px 10px' }}>
                <svg fill="#000000" height="80px" width="80px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 470 470"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M151.25,392c-4.143,0-7.5,3.358-7.5,7.5V422c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-22.5 C158.75,395.358,155.393,392,151.25,392z"></path> <path d="M318.75,392c-4.143,0-7.5,3.358-7.5,7.5v30c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-30 C326.25,395.358,322.893,392,318.75,392z"></path> <path d="M27.5,142h103.75c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H27.5c-4.143,0-7.5,3.358-7.5,7.5S23.357,142,27.5,142z"></path> <path d="M27.5,112h103.75c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H27.5c-4.143,0-7.5,3.358-7.5,7.5S23.357,112,27.5,112z"></path> <path d="M67.5,347h335c4.143,0,7.5-3.358,7.5-7.5v-115c0-4.142-3.357-7.5-7.5-7.5h-51.875c-4.143,0-7.5,3.358-7.5,7.5 s3.357,7.5,7.5,7.5H395v100H75V232h245.625c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H67.5c-4.143,0-7.5,3.358-7.5,7.5v115 C60,343.642,63.357,347,67.5,347z"></path> <path d="M163.067,141.976c4.125,0.329,7.745-2.744,8.078-6.873l5.168-64.097C177.32,58.535,188.739,48,201.25,48h67.5 c12.511,0,23.93,10.535,24.937,23.006l5.168,64.097c0.316,3.924,3.599,6.898,7.468,6.898c0.201,0,0.405-0.008,0.61-0.025 c4.129-0.333,7.206-3.95,6.873-8.079L308.638,69.8C307,49.508,289.106,33,268.75,33h-67.5c-20.356,0-38.25,16.508-39.888,36.8 l-5.168,64.097C155.861,138.026,158.938,141.643,163.067,141.976z"></path> <path d="M462.5,157H410v-52.5c0-4.142-3.357-7.5-7.5-7.5H390V74.5c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5V97h-12.5 c-4.143,0-7.5,3.358-7.5,7.5V157H7.5c-4.143,0-7.5,3.358-7.5,7.5v30c0,4.142,3.357,7.5,7.5,7.5H30v227.5c0,4.142,3.357,7.5,7.5,7.5 s7.5-3.358,7.5-7.5V377h380v52.5c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5V202h22.5c4.143,0,7.5-3.358,7.5-7.5v-30 C470,160.358,466.643,157,462.5,157z M370,112h25v45h-25V112z M425,362H45V202h380V362z M455,187H15v-15h440V187z"></path> </g> </g></svg>
                <Button style={{ marginTop: '10px' }} variant="success">
                    Docentes
                </Button>
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Docentes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-label'>Docentes</div>
                    <ObjectMultiSelect
                        value={hook.entity.teachers ?? []}
                        onChange={(e) => {
                            hook.setEntity({
                                ...hook.entity,
                                teachers: e
                            })
                        }}
                        options={teachersHook.data.map( d => ({ value: d.uuid, label: d.name }))}
                    />
                    <Button style={{ margin: '10px 0', width: '100%' }} variant="success" onClick={hook.edit}>
                        Actualizar
                    </Button>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}